export class TipOutTypes {
    public static PROGRESSIVE = 'PROGRESSIVE';
    public static POOLED = 'POOLED';
    public static PAY_PERIOD_POOLED = 'PAY_PERIOD_POOLED';
}
